import React from "react";
import styled from "styled-components";
import {ButtonColor} from "../Text";

export const ContainerTab = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 58px;
  .btn-transfer-web3 {
    width: auto;
  }

  @media screen and (max-width: 1024px) {
    & {
      margin-bottom: 35px;
      justify-content: center;
    }
  }
  @media screen and (max-width: 768px) {
    justify-content: end;
    flex-wrap: wrap;
    .btn-transfer-web3 {
      width: 100%;
    }
    .mb-half {
      width: 50% !important;
    }
  }
`
export const ContainerSubTab = styled.div`
  display: flex;
  gap: 8px;
  @media screen and (max-width: 768px) {
    width: 100%;
  }
`
export const TabItemColor = styled(ButtonColor)`
  height: 52px;
  border-radius: 15px;
  border: none;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  display: flex;
  align-items: center;
  text-align: center;
  margin-right: 15px;
  min-width: 145px;

  @media screen and (max-width: 1024px) {
    flex: 1;
    min-width: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    
    &.full-width {
      width: 100%;
    }
  }
`

export const TabItem = styled.div`
  height: 50px;
  border: 1px solid #848484;
  border-radius: 8px;
  font-weight: 400;
  font-size: 16px;
  text-align: center;
  color: #707070;
  display: flex;
  align-items: center;
  padding: 0 26px;
  margin-right: 15px;
  cursor: pointer;

  &.version-2 {
    height: 50px;
    background: linear-gradient(157.48deg, #548FEB -5.34%, #4D67C1 103.65%);
    box-shadow: 0px 5px 15px rgba(23, 40, 253, 0.333333);
    border-radius: 10px;
    border: none;
    font-weight: 700;
    font-size: 16px;
    line-height: 17px;
    text-align: center;
    color: #FFFFFF;

    @media screen and (max-width: 1024px) {
      height: 35px;
      border-radius: 10px;
      font-size: 14px;
      //width: calc(50% - 9px);
      display: flex;
      align-items: center;
      justify-content: center;
      &.full-width {
        width: 100%;
      }
    }


  }

  &.version-3 {
    height: 52px;
    background: #000000;
    border-radius: 15px;
    border: none;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #FFFFFF;

    @media screen and (max-width: 1024px) {
      //width: calc(50% - 9px);
      display: flex;
      align-items: center;
      justify-content: center;
      &.full-width {
        width: 100%;
      }
    }
  }

  &.active {
    background: #485EA8;
    border: 1px solid #F12E11;
    color: #fff;
  }

  @media screen and (max-width: 1024px) {
    & {
      height: 35px;
      border: 1px solid #848484;
      border-radius: 5px;
      font-weight: 400;
      font-size: 16px;
      line-height: 15px;
      text-align: center;
      color: #707070;
      padding: 0 12px;
    }
  }
`